import { ExtendedFAB } from '@chocolate-soup-inc/cs-frontend-components';
import { useState } from 'react';
import { FloatingActions } from '../../components/floatingActions/FloatingActions';
import { TCustomReportEntity } from '../../generated/graphql';
import { CustomReportModal } from './CustomReportModal';
import { downloadReport, TReportSheet } from './reportExport';

import './ReportPage.scss';

type TReportActionsProps = {
  data: TReportSheet;
  disabled: boolean;
  filename: string;
  customReportEntity?: TCustomReportEntity;
};

export const ReportActions = ({ data, disabled, filename, customReportEntity }: TReportActionsProps) => {
  const [customReportOpen, setCustomReportOpen] = useState(false);

  return (
    <>
      {!customReportOpen && (
        <FloatingActions>
          <div className='report-download-actions'>
            <ExtendedFAB disabled={disabled} label='CSV' leadingIcon='download' onClick={() => downloadReport(data, filename, 'csv')} variant='surface' />
            <ExtendedFAB disabled={disabled} label='XLSX' leadingIcon='download' onClick={() => downloadReport(data, filename, 'xlsx')} variant='surface' />
          </div>
          {customReportEntity && <ExtendedFAB label='Custom report' leadingIcon='tune' onClick={() => setCustomReportOpen(true)} variant='surface' />}
        </FloatingActions>
      )}
      {customReportOpen && customReportEntity && <CustomReportModal entity={customReportEntity} onClose={() => setCustomReportOpen(false)} />}
    </>
  );
};
